import { render, staticRenderFns } from "./SupportAuthorizationDisclaimer.vue?vue&type=template&id=5766d138&"
import script from "./SupportAuthorizationDisclaimer.vue?vue&type=script&lang=js&"
export * from "./SupportAuthorizationDisclaimer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports